import React from "react";
import { Input, Button, message } from "antd";

import './index.sass';
import api from "../../utils/api";


export default class Remark extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            remark: ''
        }
    }

    closeHandle = () => {
        this.props.colsePop({ show: false })
    }

    addOrderRemark=async()=>{
        let { remark } = this.state;
        let { orderId } = this.props;

        let param = {
            remark_detail: remark,
            remark_type: 3,
            order_id: orderId,
        }

        let res = await api('add-order-remark',param);

        if(res['code'] === 200){
            message.success('备注成功！')
            this.props.update(true)
        }else{
            message.error(res['message'])
        }
    }

    render() {
        return (
            <div className='remark'>
                <div className='close'/>
                <div className='popBox'>
                    <p className='title'>
                        备注
                    </p>
                    <div className='popContent'>
                        <div className='popCtx'>
                            <div className='flex line'>
                                <label>备注：</label>
                                <Input.TextArea onChange={(e)=>{ this.setState({remark: e.target.value}) }} showCount maxLength={20} className='width280' placeholder="请输入分类名称，最多20字" />
                            </div>

                            <div className='flex line contrlBtn'>
                                <Button onClick={async ()=>{ await this.addOrderRemark() }} className='themeBtn mgr50 mgr50'>保存</Button>
                                <Button onClick={() => { this.closeHandle() }}>取消</Button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}